import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { ipValidators, descriptionValidators } from '../utils/validators';

export enum ColumnKeys {
  IP = 'ip',
  DESCRIPTION = 'description',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.IP,
      header: translateFn('IP/mask'),
      columnType: IColumnType.TEXT,
      validators: ipValidators(),
    },
    {
      key: ColumnKeys.DESCRIPTION,
      header: translateFn('Description'),
      columnType: IColumnType.TEXT,
      validators: descriptionValidators(),
    },

    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
